/* This file was generated automatically. Do not edit manually. */

export enum OnboardingAuditFieldIdentifier {
    TasksCompleted = 'TasksCompleted',
    EmployeesAdded = 'EmployeesAdded',
    EmployeesActivated = 'EmployeesActivated',
    EmployeeMfaSetup = 'EmployeeMfaSetup',
    DepartmentsAdded = 'DepartmentsAdded',
    EmployeesAssignedToDepartments = 'EmployeesAssignedToDepartments',
    CompanyProfilesAdded = 'CompanyProfilesAdded',
    TravelAgentContractsAdded = 'TravelAgentContractsAdded',
    BookableRatesSetup = 'BookableRatesSetup',
    PropertySettingsCompleted = 'PropertySettingsCompleted',
    PropertyLogoAndSignInImageUploaded = 'PropertyLogoAndSignInImageUploaded',
    RateGroupsSetUp = 'RateGroupsSetUp',
    PaymentAutomationEnabled = 'PaymentAutomationEnabled',
    SettlementRulesSetUp = 'SettlementRulesSetUp',
    CancellationPoliciesSetUp = 'CancellationPoliciesSetUp',
    RestrictionsAdded = 'RestrictionsAdded',
    BookingEnginesAdded = 'BookingEnginesAdded',
    AccountingConfigurationSetUp = 'AccountingConfigurationSetUp',
    RequireAccountingCategorySetupActive = 'RequireAccountingCategorySetupActive',
    ExternalPaymentTypesSetUp = 'ExternalPaymentTypesSetUp',
    GatewayPaymentTypesMapped = 'GatewayPaymentTypesMapped',
    MewsTerminalPaymentTypesMapped = 'MewsTerminalPaymentTypesMapped',
    BillHeaderAndFooterSetUp = 'BillHeaderAndFooterSetUp',
    AccountingCategoriesSetUp = 'AccountingCategoriesSetUp',
    CashiersAssigned = 'CashiersAssigned',
    BillAndInvoiceCountersConfigured = 'BillAndInvoiceCountersConfigured',
    RoutingRulesSetUp = 'RoutingRulesSetUp',
    EhwSetUp = 'EhwSetUp',
    EmailTemplatesCustomized = 'EmailTemplatesCustomized',
    AdditionalServicesSetUp = 'AdditionalServicesSetUp',
    AdditionalServiceAccountingCategoriesSetUp = 'AdditionalServiceAccountingCategoriesSetUp',
    AdditionalServiceProductAccountingCategoriesSetUp = 'AdditionalServiceProductAccountingCategoriesSetUp',
    AdditionalServiceProductTaxesSetUp = 'AdditionalServiceProductTaxesSetUp',
    BookableServicesGeneralSettingsSetUp = 'BookableServicesGeneralSettingsSetUp',
    BookableServicesAutomaticNoShowCancellationDisabled = 'BookableServicesAutomaticNoShowCancellationDisabled',
    BookableServicesAccountingSettingsSetUp = 'BookableServicesAccountingSettingsSetUp',
    QrCodesSetUp = 'QrCodesSetUp',
    BookableServiceProductsSetUp = 'BookableServiceProductsSetUp',
    BookableServiceProductCategoriesSetUp = 'BookableServiceProductCategoriesSetUp',
    BookableServiceProductAccountingCategoriesSetUp = 'BookableServiceProductAccountingCategoriesSetUp',
    BookableProductTaxesSetUp = 'BookableProductTaxesSetUp',
    ProductRulesSetUp = 'ProductRulesSetUp',
    ServicePromotionsSetUp = 'ServicePromotionsSetUp',
    ChannelManagerConfigured = 'ChannelManagerConfigured',
    PrintersSetUp = 'PrintersSetUp',
    KeyCuttersSetUp = 'KeyCuttersSetUp',
    TerminalsSetUp = 'TerminalsSetUp',
    AnalyticsSetUp = 'AnalyticsSetUp',
    AccountingIntegrationsSetUp = 'AccountingIntegrationsSetUp',
    SpacesAdded = 'SpacesAdded',
    SpaceCategoriesAdded = 'SpaceCategoriesAdded',
    SpacesAssigned = 'SpacesAssigned',
    SpaceCategoriesAssigned = 'SpaceCategoriesAssigned',
    SpaceCategorySettingsSetUp = 'SpaceCategorySettingsSetUp',
    KycStatus = 'KycStatus',
    UnpaidInvoiceOverview = 'UnpaidInvoiceOverview',
    InitialEntitySetup = 'InitialEntitySetup',
    MewsUniversityCoursesCompleted = 'MewsUniversityCoursesCompleted',
}
